    <template>
  <div class="order-list">
    <!-- 导航 -->
    <van-nav-bar title="我的订单" class="myOrder">
      <i
        class="icon-home iconfont f18"
        slot="left"
        @click="$router.push('/')"
      ></i>
    </van-nav-bar>
    <!-- 标签栏 -->
    <!-- <div style="color:#797d82;"> -->
    <van-sticky>
      <van-tabs v-model="currTab">
        <van-tab title="全部" name="all"></van-tab>
        <van-tab title="待付款" name="wait"></van-tab>
        <van-tab title="待发货" name="send"></van-tab>
        <van-tab title="已取消" name="cancel"></van-tab>
      </van-tabs>
    </van-sticky>

    <!-- 商品详情 -->
    <div class="list">
      <div
        tag="div"
        class="item pl-15 pr-15"
        v-for="(item, index) in showList"
        :key="item.orderId"
      >
        <router-link
          :to="`/order/detail/${item.orderId}`"
          class="card pl-15 pr-15 pb-15"
        >
          <!-- 单个商品 -->
          <div
            v-show="item.carts.length === 1"
            style="height: 100px"
            class="flex jc-sb aic"
            v-for="(cart, index1) in item.carts"
            :key="index1"
          >
            <p class="img-box">
              <img v-show="index1 < 4" :src="cart.imgUrl" alt class="img" />
            </p>
            <div class="desc flex2 jc-sb fg1" style="height: 68px">
              <p class="f14 lh15" style="width: 200px">{{ cart.masterName }}</p>
              <p class="flex jc-sb">
                <span class="flex aic">
                  <span class="f10">￥</span>
                  <span>{{ cart.price | formatMoney }}</span>
                </span>
                <span class="f999 f14">x {{ cart.buyNum }}</span>
              </p>
            </div>
          </div>

          <!-- 多个商品 -->
          <div
            v-show="item.carts.length > 1"
            style="height: 100px"
            class="flex jc-sb aic"
            :key="item.orderId"
          >
            <p class="img-box flex">
              <img
                v-show="index2 < 4"
                v-for="(cart, index2) in item.carts"
                :key="cart.cartId"
                :src="cart.imgUrl"
                class="img"
                alt
              />
            </p>
            <van-icon color="#999" name="arrow" />
          </div>
        </router-link>
        <!-- 底部 -->
        <div slot="footer" style="height: 40px" class="border-line">
          <p style="line-height: 40px" class="flex jc-sb aic">
            <span class="mr-10 f14">共{{ item.carts | getLenth }}件商品</span>
            <span class="f14 fg1">
              实付
              <span class="red">￥{{ item.allFee | formatMoney }}</span>
            </span>
            <van-icon
              name="close"
              size="22"
              color="#c03131"
              @click.native.prevent="delOrder(item.orderId, index)"
            />
          </p>
        </div>
        <div class="margin-top flex jc-sb aic">
          <span class="flr f14" v-if="item.orderStatus == '00'"
            >订单状态: 已取消</span
          >
          <span class="flr f14" v-if="item.orderStatus == '01'"
            >订单状态: 已支付</span
          >
          <span class="flr flex f14" v-if="item.orderStatus == '02'"
            >剩余支付时间: <TimeBox :createTime="item.createTime" />
          </span>
          <van-icon
            name="cart-o"
            v-if="item.orderStatus == '00'"
            size="22"
            @click.native.prevent="reBuy(item)"
          />
          <!-- <van-button
            size="small"
            class="buttosize"
            v-if="item.orderStatus == '00'"
            @click.native.prevent="reBuy(item)"
            >重新购买</van-button> -->
          <van-icon
            name="cart-o"
            v-if="item.orderStatus == '01'"
            size="22"
            @click.native.prevent="reBuy(item)"
          />
          <van-icon
            name="refund-o"
            size="22"
            v-if="item.orderStatus == '02'"
            @click.native.prevent="showPay(item)"
          />
        </div>
        <div style="background: #f4f4f4; height: 10px; margin-top: 10px"></div>
      </div>
    </div>
    <van-action-sheet v-model="show" title="请选择支付方式">
      <PayWay @toPay="toPay" :allFee="allFee"></PayWay>
    </van-action-sheet>
    <van-empty v-if="!showList.length" description="没有订单" />
  </div>
</template>

<script>
import TimeBox from "@/components/TimeBox";
import PayWay from "../submit/PayWay.vue";
export default {
  components: {
    PayWay,
    TimeBox,
  },
  data() {
    return {
      payInfo: {},
      allFee: 0,
      show: false,
      currPage: 1,
      currTab: "all",
      orderList: [],
      showList: [],
    };
  },

  watch: {
    currTab(currTab) {
      switch (currTab) {
        case "wait":
          this.showList = this.orderList.filter(
            (item) => item.orderStatus === "02"
          );
          break;
        case "send":
          this.showList = this.orderList.filter(
            (item) => item.orderStatus === "01"
          );
          break;
        case "cancel":
          this.showList = this.orderList.filter(
            (item) => item.orderStatus === "00"
          );
          break;
        default:
          this.showList = this.orderList;
      }
    },
  },

  created() {
    this.getOrderList();
  },

  filters: {
    getLenth(carts) {
      return carts.map((item) => item.buyNum).reduce((a, b) => a + b, 0);
    },
  },

  methods: {
    createWs() {
      let env = process.env.NODE_ENV;
      let wsurl =
        env === "development" ? "localhost:3003" : "43.136.85.99:3003";
      var ws = new WebSocket(`ws://${wsurl}/ws?id=` + this.orderId);
      // 响应onmessage事件:
      ws.onmessage = (msg) => {
        let data = JSON.parse(msg.data);
        ws.close();
        this.show = false;
        if (data.orderStatus) {
          if (data.orderStatus == "01") {
            this.$dialog
              .alert({
                message: "支付成功",
              })
              .then(() => {
                this.$router.push("/order/detail/" + this.orderId);
              });
          } else {
            this.$dialog
              .alert({
                message: "支付失败",
              })
              .then(() => {
                this.$router.push("/order/detail/" + this.orderId);
              });
          }
        }
      };
      ws.onopen = () => {
        // 给服务器发送一个字符串:
        ws.send("Hello!");
      };
    },

    delOrder(orderId, index) {
      this.$dialog
        .confirm({
          title: "",
          message: "确定要删除吗",
        })
        .then(() => {
          this.$post("/order/del", { orderId }).then((res) => {
            this.orderList.splice(index,1);
          });
        });
    },
    // 显示支付弹窗
    showPay(item) {
      this.allFee = item.allFee;
      this.show = true;
      this.payInfo = {
        orderId: item.orderId,
        createTime: item.createTime,
        allFee: item.allFee,
      };
    },
    toPay(payWay) {
      // 将相关参数传到下一个页面
      let query = {
        ...this.payInfo,
        payWay: payWay == 1 ? "wx" : "zfb",
      };
      let url = "/order/pay";
      this.$post(url, query).then((res) => {});
    },

    reBuy(item) {
      this.$router.push({
        path: "/order/submit",
        query: { preOrderId: item.preOrderId },
      });
    },

    getOrderList() {
      let url = "/order/list";
      this.$loading(true);
      this.$get(url, { currPage: this.currPage })
        .then((result) => {
          this.orderList = result.list;
          this.showList = result.list;
          this.$loading(false);
        })
        .catch((err) => {
          this.$fail(err);
        });
    },
  },
};
</script>
<style lang="less">
@import "./index.less";
</style>